import {Component, OnInit, ViewChild, OnDestroy} from '@angular/core';
import {RegistriesService} from '../../service';
import {TableReactiveUrlController} from '@amlCore/tableReactive';
import {ActivatedRoute, Params, Router} from '@angular/router';
import {AlertPanelComponent, AlertService} from '@amlCore/components';
import {DictInfo} from '../../model';
import {AccessJson} from '@amlCore/models';
import {CheckDictEnum, RegistriesAccessEnum} from '@amlCore/enums';
import {ResourceService, TableService, UserService, VisitedService} from '@amlCore/services';
import {Utils} from '@amlCore/utils';


@Component({
  selector: 'app-registry-mass-found-info',
  templateUrl: './massFoundInfo.component.html'
})
export class MassFoundInfoComponent extends TableReactiveUrlController implements OnInit, OnDestroy {

  isShowVisited = true;
  loadCheckList = {};
  @ViewChild('alertObjCheck', {static: false}) alertObjToCheck: AlertPanelComponent;

  constructor(private readonly regSrv: RegistriesService,
              private readonly resourceSrv: ResourceService,
              private readonly userSrv: UserService,
              private readonly alertSrv: AlertService,
              protected readonly activatedRoute: ActivatedRoute,
              protected readonly visitedService: VisitedService,
              protected readonly tableService: TableService,
              protected readonly router: Router) {
    super(router, activatedRoute, visitedService, tableService, {pageSize: 20, sort: 'uploaded', dir: 'DESC'});
  }

  massFoundInfoEntries: Array<DictInfo> = [];
  access: AccessJson;

  ngOnInit() {
    this.access = this.userSrv.getAccess(RegistriesAccessEnum.QREF_MSFOUND);
    this.activatedRoute.queryParams.subscribe(data => {
      this.loadList(this.syncParams(data));
    });
  }

  public onPageChange(params) {
    this.navigate(this.getParams(params));
  }

  public loadList(params?: any) {
    const queryParams = this.getParams(params);
    this.resourceSrv.getMassFoundInfo(queryParams).subscribe(data => {
      this.massFoundInfoEntries = data.content;
      this.total = data.totalElements;
      this.scrollRun();
    });
  }

  public edit(msFound: DictInfo) {
    this.tableService.saveScrollPosition(this.commonKeyStore);
    this.router.navigate(['registries/massFoundSubject', msFound.id]);
  }

  public onSearch() {
    const queryParams = this.getSearchPage(this.filter);
    queryParams["sort"] = "firstName";
    queryParams["dir"] = "ASC";
    this.tableService.saveScrollPosition(this.commonKeyStore);
    this.router.navigate(['registries/massFoundInfoAll'], {
      queryParams: {q: Utils.encodeJSONBase64(queryParams)} as Params
    });
  }

  public remove(confirm, massFound: DictInfo) {
    this.alertSrv.clear();
    this.regSrv.removeFile('/api/v1/qref/msfound/remove', {id: massFound.id}).subscribe(data => {
      this.alertSrv.success(`Запись ${massFound.name} удалена!`);
      this.loadList();
    });
  }

  /**
   * Проверка по факторам риска
   * @param item - элемент проверки
   */
  public checkRiskFactor(item: DictInfo) {
    this.regSrv.doCheckRiskFactor(item, CheckDictEnum.MSFOUND, this.loadCheckList, this.alertObjToCheck);
  }

  /**
   * метод получения объекта плоского фильтра
   * @param data объект фильтра с полями
   */
  public getFilterObject(data) {
    const filter = this.tableService.getFilterSubject(data);
    return this.getFilterPlanObject(filter);
  }

  ngOnDestroy() {
    this.checkScrollOptions();
  }
}
